import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { WorkspacePremium as WorkspacePremiumIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { DOCUMENT } from '../constants/documentTheme';
import { getTripPassBadgeLabel, getTripPassTooltip, isTripCovered } from '../utils/tripPassUtils';

const variantStyles = {
  overlay: {
    fontWeight: 700,
    fontSize: 11,
    height: 22,
    maxWidth: 180,
    backgroundColor: 'rgba(255, 251, 235, 0.95)',
    color: '#92400e',
    border: '1px solid rgba(245, 158, 11, 0.5)',
    '& .MuiChip-icon': {
      marginLeft: '4px',
      color: '#92400e !important',
      fontSize: '14px !important',
    },
    '& .MuiChip-label': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  cover: {
    fontWeight: 500,
    fontSize: 9.5,
    letterSpacing: '0.16em',
    textTransform: 'uppercase',
    height: 22,
    maxWidth: 200,
    borderRadius: 0,
    backgroundColor: '#C9A961',
    color: '#2A070C',
    border: 0,
    '& .MuiChip-icon': {
      marginLeft: '4px',
      color: '#2A070C !important',
      fontSize: '13px !important',
    },
    '& .MuiChip-label': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      px: 1,
    },
  },
  header: {
    fontWeight: 500,
    fontSize: { xs: '0.625rem', sm: '0.6875rem' },
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    height: 28,
    maxWidth: { xs: 160, sm: 220 },
    backgroundColor: 'transparent',
    color: DOCUMENT.ivory,
    borderRadius: 0,
    border: '1px solid rgba(246,239,228,0.28)',
    '& .MuiChip-icon': {
      marginLeft: '4px',
      color: `${DOCUMENT.ivory} !important`,
      fontSize: { xs: '12px !important', sm: '14px !important' },
    },
    '& .MuiChip-label': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  sidebar: {
    fontWeight: 700,
    fontSize: '0.75rem',
    height: 28,
    backgroundColor: '#fffbeb',
    color: '#92400e',
    border: '1px solid rgba(245, 158, 11, 0.45)',
    '& .MuiChip-icon': {
      color: '#92400e !important',
    },
  },
};

const TripPassBadge = ({ trip, variant = 'overlay', size = 'small', sx = {} }) => {
  const { t } = useTranslation();

  if (!isTripCovered(trip)) {
    return null;
  }

  const label = getTripPassBadgeLabel(trip.upgrade_info, t);
  if (!label) {
    return null;
  }

  return (
    <Tooltip title={getTripPassTooltip(trip.upgrade_info, t)}>
      <Chip
        icon={<WorkspacePremiumIcon />}
        label={label}
        size={size}
        sx={{ ...(variantStyles[variant] || variantStyles.overlay), ...sx }}
      />
    </Tooltip>
  );
};

export default TripPassBadge;
